export enum StepKeys {
  notStarted = 'notStarted',
  personalData = 'personaDetails',
  identification = 'identification',
  bankData = 'bankData',
  incomeCheck = 'incomeCheck',
  kvk = 'kvk',
  kadaster = 'kadaster',
  bkr = 'bkr',
  landlordStatement = 'landlordStatement',
  employeeIntegrity = 'employeeIntegrity',
  education = 'education',
  certificateOfConduct = 'certificateOfConduct',
  confirmation = 'confirmation',
  completed = 'completed',
}

export enum Steps {
  notStarted = 'notStarted',
  personalData = 'personalData',
  identification = 'identification',
  bankData = 'bankData',
  incomeCheck = 'incomeCheck',
  kvk = 'kvk',
  kadaster = 'kadaster',
  bkr = 'bkr',
  landlordStatement = 'landlordStatement',
  employeeIntegrity = 'employeeIntegrity',
  education = 'education',
  certificateOfConduct = 'certificateOfConduct',
  confirmation = 'confirmation',
  completed = 'completed',
}
